import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import Users from './pages/Users/Users';
import Reports from './pages/Reports/Reports';
import Home from './pages/Home/Home';
import Appointments from './pages/Appointments/Appointments';
import NotificationsUI from './pages/Notifications/Notifications';
import Audios from './pages/Audio/Audio';
import Settings from './pages/Settings/Settings';
import Login from './pages/Login/Login';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import ErrorUI from './pages/Error/Error';
import ResolutionError from './pages/ResolutionError/ResolutionError';
import { getCurrentDimension } from "./helpers/HelperFunctions";

import './App.css';
import './responsive.scss';
import ForgetPassword from "./pages/ForgetPassword/ForgetPassword";

function App() {
  var screenWidth = getCurrentDimension().width

  const AppRoutes = () => {
    let routes = useRoutes([
      { path: "/", element: <Login /> },
      { path: "/login", element: <Login /> },
      { path: "/forget-password", element: <ForgetPassword /> },
      { path: "/reset-password", element: <ResetPassword /> },
      { path: "/privacy-policy", element: <PrivacyPolicy /> },
      { path: "/dashboard/home", element: screenWidth > 425 ? <Home /> : <Reports /> },
      { path: "/dashboard/reports/:id?", element: <Reports /> },
      { path: "/dashboard/audio", element: <Audios /> },
      { path: "/dashboard/users", element: <Users /> },
      { path: "/dashboard/appointments", element: screenWidth > 425 ? <Appointments /> : <Reports /> },
      { path: "/dashboard/settings", element: <Settings /> },
      { path: "/dashboard/notifications", element: <NotificationsUI /> },
      { path: "*", element: <ErrorUI /> }
    ]);

    return routes;
  };

  return (
    <div className="App">
      {(getCurrentDimension().width > 425)
        ? (<Router>
          <AppRoutes />
        </Router>)
        : (<ResolutionError />)
      }
    </div>
  );
}

export default App;
